export default {

    // CONNECTOR AUTHENTICATION
    CONNECTOR_SIGNUP_REQUEST: {
        url: "/api/v1/connector/authentication/initial",
        method: "post",
    },

    CONNECTOR_SIGNUP_VERIFY: {
        url: "/api/v1/connector/authentication/initial/verify",
        method: "put",
    },

    CONNECTOR_LOGIN_WITH_CREDS: {
        url: "/api/v1/connector/authentication/credential/login",
        method: "post",
    },

    CONNECTOR_PASSWORD_RESET: {
        url: "/api/v1/connector/authentication/credential/change",
        method: "put",
    },

    CONNECTOR_LOGIN_REQUEST_VIA_OTP: {
        url: "/api/v1/connector/authentication/otp/request",
        method: "post",
    },

    CONNECTOR_LOGIN_VERIFY_VIA_OTP: {
        url: "/api/v1/connector/authentication/otp/verify",
        method: "put",
    },

    // CONNECTOR 

    GET_CONNECTOR_STATUS: {
        url: "/api/v1/connector/status",
        method: "get",
    },

    GET_CONNECTOR_DETAILS: {
        url: "/api/v1/connector/details",
        method: "get",
    },

    GET_CONNECTOR_LEADS_FOR_ADMIN: {
        url: "/api/v1/connector/leads/admin-all",
        method: "get",
    },

    GET_ALL_CONNECTORS: {
        url: "/api/v1/connector",
        method: "get",
    },

    EXPORT_CONNECTORS: {
        url: "/api/v1/connector/export",
        method: "get",
    },

    EXPORT_ALL_CONNECTOR_LEADS: {
        url: "/api/v1/connector/leads/admin-export",
        method: "get",
    },

    GET_CONNECTOR_DETAILS_BY_ID: {
        url: "/api/v1/connector/{connector_id}",
        method: "get",
    },

    UPDATE_CONNECTOR_DETAILS_BY_ID: {
        url: "/api/v1/connector/{connector_id}",
        method: "put",
    },

    UPDATE_CONNECTOR_DELETION_DETAILS: {
        url: "/api/v1/connector/status/{connector_id}",
        method: "put",
    },

    CONNECTOR_SIGNUP_SUBMIT: {
        url: "/api/v1/connector/registration",
        method: "post",
    },

    // CONNECTOR KYC

    GET_CONNECTOR_DIGILOCKER_URL_FOR_USER_CONSENT: {
        url: "/api/v1/connector/kyc/aadhar/request",
        method: "post"
    },

    GET_CONNECTOR_PAN_DETAILS: {
        url: "/api/v1/connector/kyc/pan/request",
        method: "post"
    },

    VERIFY_CONNECTOR_PAN: {
        url: "/api/v1/connector/kyc/pan/verify",
        method: "post"
    },

    UPDATE_CONNECTOR_DOCS: {
        url: "/api/v1/connector/kyc/document/upload",
        method: "put"
    },

    SEND_AGREEMENT_TO_CONNECTOR_FOR_ESIGN: {
        url: "/api/v1/connector/kyc/agreement",
        method: "post"
    },

    // CONNECTOR APPLICATION

    ADD_CONNECTOR_APPLICATION: {
        url: "/api/v1/connector/application",
        method: "post"
    },

    GET_CONNECTOR_APPLICATIONS: {
        url: "/api/v1/connector/application/all",
        method: "get"
    },

    // CONNECTOR BANK DETAILS

    ADD_CONNECTOR_BANK_DETAILS: {
        url: "/api/v1/connector/bankdetails",
        method: "post"
    },

    UPDATE_CONNECTOR_BANK_DETAILS: {
        url: "/api/v1/connector/bankdetails",
        method: "put"
    },

    // CONNECTOR LEADS

    ADD_CONNECTOR_LEADS: {
        url: "/api/v1/connector/leads",
        method: "post"
    },

    GET_CONNECTOR_LEADS: {
        url: "/api/v1/connector/leads/all",
        method: "get"
    },

    GET_CONNECTOR_LEAD_BY_ID: {
        url: "/api/v1/connector/leads/{connector_lead_id}",
        method: "get"
    },

    UPDATE_CONNECTOR_LEAD_BY_ID: {
        url: "/api/v1/connector/leads/{connector_lead_id}",
        method: "put"
    },

    SEND_CONNECTOR_LEADS_FOR_PAYOUT: {
        url: "/api/v1/connector/leads/send-payout",
        method: "put"
    },

}